import React from 'react'
import { connect } from "react-redux";
import ItemEditComponent from './TextEdit'
import Select from './SelectObjComponent'
import { colors } from '../theme';
import SwitchEditComponent from './SwitchEdit'
import { format, calculateInvoiceTotals } from '../helpers/invoiceNumber'
import Alert from "sweetalert2";
import TaxComponent from './TaxComponent'
import { saveLineItem, deleteLineItem } from '../reducers/companies'

import {
  MDBCol,
  MDBRow,
  MDBDataTable,
  MDBModal,
  MDBModalFooter,
  MDBModalBody,
  MDBModalHeader,
  MDBBtn
} from 'mdbreact';

const ItemFooterComponent = ({ lineItems, setDiscount, discountObj, taxObj, viewOnly }) => {

  let { total, preTotal, discount, tax, tax2 } = calculateInvoiceTotals(lineItems, discountObj);

  const toggleButtonStyle = (active) => ({
    padding: '8px 16px',
    borderRadius: 6,
    border: 'none',
    fontWeight: 500,
    cursor: 'pointer',
    fontSize: 13,
    transition: 'all 0.2s ease',
    background: active ? '#19a6b7' : 'transparent',
    color: active ? 'white' : '#666'
  });

  return (
    <div style={{
      display: 'flex',
      gap: 24,
      marginTop: 20,
      padding: 20,
      background: '#f8f9fa',
      borderRadius: 8,
      border: '1px solid #e8e8e8'
    }}>
      {/* Discount Section */}
      <div style={{ flex: 1 }}>
        {!viewOnly && (
          <div>
            <SwitchEditComponent header={'Apply Discount'} onChangeText={setDiscount} prop={'hasDiscount'} value={discountObj.hasDiscount} />

            {discountObj.hasDiscount && (
              <div style={{ marginTop: 12 }}>
                {/* Discount Type Toggle */}
                <div style={{
                  display: 'inline-flex',
                  background: '#e8e8e8',
                  borderRadius: 8,
                  padding: 4,
                  marginBottom: 12
                }}>
                  <button
                    type="button"
                    onClick={() => setDiscount('discountType', 'Percentage')}
                    style={toggleButtonStyle(discountObj.discountType !== 'Amount')}
                  >
                    Percentage
                  </button>
                  <button
                    type="button"
                    onClick={() => setDiscount('discountType', 'Amount')}
                    style={toggleButtonStyle(discountObj.discountType === 'Amount')}
                  >
                    Amount
                  </button>
                </div>

                {/* Discount Value Input */}
                <div style={{ display: 'flex', alignItems: 'center', maxWidth: 200 }}>
                  {discountObj.discountType === 'Amount' && (
                    <span style={{
                      padding: '10px 12px',
                      background: '#1a3a4a',
                      color: 'white',
                      borderRadius: '6px 0 0 6px',
                      fontWeight: 500
                    }}>R</span>
                  )}
                  <input
                    type="number"
                    onChange={(v) => setDiscount('discountValue', v.target.value)}
                    value={discountObj.discountValue}
                    style={{
                      flex: 1,
                      padding: '10px 12px',
                      border: '1px solid #ddd',
                      borderRadius: discountObj.discountType === 'Amount' ? '0 6px 6px 0' : '6px 0 0 6px',
                      fontSize: 14,
                      outline: 'none'
                    }}
                  />
                  {discountObj.discountType !== 'Amount' && (
                    <span style={{
                      padding: '10px 12px',
                      background: '#1a3a4a',
                      color: 'white',
                      borderRadius: '0 6px 6px 0',
                      fontWeight: 500
                    }}>%</span>
                  )}
                </div>
              </div>
            )}
          </div>
        )}

        {viewOnly && (
          <div style={{ color: '#666' }}>
            {discountObj.hasDiscount ? (
              <div>
                <span style={{ fontWeight: 500 }}>Discount: </span>
                {discountObj.discountType === 'Amount' ? 'R ' + discountObj.discountValue : discountObj.discountValue + '%'}
              </div>
            ) : (
              <span>No Discount</span>
            )}
          </div>
        )}
      </div>

      {/* Totals Section */}
      <div style={{ minWidth: 250 }}>
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          padding: '8px 0',
          borderBottom: '1px solid #e8e8e8',
          color: '#666'
        }}>
          <span>Subtotal</span>
          <span style={{ fontWeight: 500 }}>R {preTotal.toFixed(2)}</span>
        </div>

        {discountObj.hasDiscount && (
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            padding: '8px 0',
            borderBottom: '1px solid #e8e8e8',
            color: '#e84651'
          }}>
            <span>Discount</span>
            <span style={{ fontWeight: 500 }}>- R {Math.abs(discount).toFixed(2)}</span>
          </div>
        )}

        {!!tax && (
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            padding: '8px 0',
            borderBottom: '1px solid #e8e8e8',
            color: '#666'
          }}>
            <span>{taxObj.tD} ({taxObj.tV}%)</span>
            <span style={{ fontWeight: 500 }}>R {tax.toFixed(2)}</span>
          </div>
        )}

        {!!tax2 && (
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            padding: '8px 0',
            borderBottom: '1px solid #e8e8e8',
            color: '#666'
          }}>
            <span>{taxObj.t2D} ({taxObj.t2V}%)</span>
            <span style={{ fontWeight: 500 }}>R {tax2.toFixed(2)}</span>
          </div>
        )}

        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          padding: '12px 0',
          marginTop: 4,
          color: '#1a3a4a'
        }}>
          <span style={{ fontSize: 16, fontWeight: 600 }}>Total</span>
          <span style={{ fontSize: 20, fontWeight: 700 }}>R {total.toFixed(2)}</span>
        </div>
      </div>
    </div>
  )
}

const ModalView = ({ myPriceListItems, addLineItem, entityId, index, setNewLineFromItem, setModalVisible, modalVisible, newLineItem, clearLineItem, tax, accounts, suppliers, deleteSavedItem, saveLineItem, entities }) => {

  setNewLineFromItem = (item) => {
    if (item) {
      setItem({
        id: item._id,
        code: item.code,
        qty: 1,
        description: item.description,
        ledgerAccountId: item.ledgerAccountId,
        notes: item.notes,
        price: item.price,
        ...tax
      });
    }
  }

  const [item, setItem] = React.useState({
    id: newLineItem._id,
    code: newLineItem.code,
    qty: newLineItem.qty || 1,
    description: newLineItem.description,
    ledgerAccountId: newLineItem.ledgerAccountId,
    notes: newLineItem.notes,
    price: newLineItem.price,
    ...tax
  });
  const [editItem, setEditItem] = React.useState();
  const [showSaved, toggleSaved] = React.useState(false);
  const [error, setError] = React.useState('');
  const [selectedItem, setSelectedItem] = React.useState();
  const [searchTerm, setSearchTerm] = React.useState('');

  // Update item state when newLineItem changes
  React.useEffect(() => {
    setItem({
      id: newLineItem._id,
      code: newLineItem.code,
      qty: newLineItem.qty || 1,
      description: newLineItem.description,
      ledgerAccountId: newLineItem.ledgerAccountId,
      notes: newLineItem.notes,
      price: newLineItem.price,
      category: newLineItem.category,
      hasTax: newLineItem.hasTax,
      hasSecondTax: newLineItem.hasSecondTax,
      ...tax
    });
  }, [newLineItem]);

  const handleItemChange = (prop, value) => {
    var t = { ...selectedItem };
    if (prop == 'price') value = parseFloat(value);
    t[prop] = value;
    setSelectedItem(t);
  }

  const handleOverrideDelete = (clientId) => {
    var t = { ...selectedItem };
    delete t.overrides[clientId]
    setSelectedItem(t);
  }

  const handleOverrideChange = (clientId, price) => {
    var t = { ...selectedItem };
    t.overrides[clientId] = price
    setSelectedItem(t);
  }

  const onChangeText = (prop, value) => {
    if (prop == 'qty') value = parseInt(value);
    if (prop == 'price') value = parseFloat(value);
    var t = { ...item };
    t[prop] = value;
    if (!t.description) setError('Please enter a description');
    else if (!t.qty || !t.price) setError('Both Price and Qty must be entered');
    else setError();
    setItem(t);
  }

  // Styles
  const inputStyle = {
    width: '100%',
    padding: '12px 14px',
    border: '1px solid #ddd',
    borderRadius: 8,
    fontSize: 14,
    outline: 'none',
    transition: 'border-color 0.2s ease'
  };

  const labelStyle = {
    display: 'block',
    fontSize: 12,
    fontWeight: 600,
    color: '#1a3a4a',
    marginBottom: 6,
    textTransform: 'uppercase',
    letterSpacing: '0.3px'
  };

  const fieldGroupStyle = {
    marginBottom: 16
  };

  const buttonStyle = {
    padding: '12px 24px',
    borderRadius: 8,
    border: 'none',
    fontWeight: 500,
    cursor: 'pointer',
    fontSize: 14,
    display: 'inline-flex',
    alignItems: 'center',
    gap: 8,
    transition: 'all 0.2s ease'
  };

  const sectionStyle = {
    padding: 16,
    background: '#f8f9fa',
    borderRadius: 8,
    marginBottom: 16
  };

  // Filter saved items
  const filteredItems = myPriceListItems.filter(i =>
    i.description.toLowerCase().includes(searchTerm.toLowerCase()) ||
    (i.code && i.code.toLowerCase().includes(searchTerm.toLowerCase()))
  ).sort((a, b) => a.description < b.description ? -1 : 1);

  return (
    <MDBModal isOpen={modalVisible} size="lg">
      {/* Custom Header */}
      <div style={{
        background: '#1a3a4a',
        padding: '16px 24px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
      }}>
        <h5 style={{ margin: 0, color: 'white', fontWeight: 600 }}>
          <i className={`fas ${showSaved ? (editItem ? 'fa-edit' : 'fa-list') : 'fa-plus-circle'}`} style={{ marginRight: 10 }}></i>
          {!showSaved ? (index !== undefined ? 'Edit Item' : 'Add Item') : !editItem ? 'Saved Items' : 'Edit Saved Item'}
        </h5>
        <button
          onClick={() => { clearLineItem(); setModalVisible(false); }}
          style={{ background: 'transparent', border: 'none', color: 'white', fontSize: 20, cursor: 'pointer' }}
        >
          <i className="fas fa-times"></i>
        </button>
      </div>

      <MDBModalBody style={{ padding: 24 }}>
        {/* Error Alert */}
        {!!error && (
          <div style={{
            background: '#fef0f0',
            border: '1px solid #e84651',
            borderRadius: 8,
            padding: '12px 16px',
            marginBottom: 20,
            color: '#e84651',
            display: 'flex',
            alignItems: 'center',
            gap: 10
          }}>
            <i className="fas fa-exclamation-circle"></i>
            {error}
          </div>
        )}

        {/* Saved Items List View */}
        {showSaved && !editItem && (
          <div>
            {/* Search */}
            <div style={{ marginBottom: 16, position: 'relative' }}>
              <i className="fas fa-search" style={{ position: 'absolute', left: 14, top: '50%', transform: 'translateY(-50%)', color: '#999' }}></i>
              <input
                type="text"
                placeholder="Search saved items..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                style={{ ...inputStyle, paddingLeft: 42 }}
              />
            </div>

            {/* Items List */}
            <div style={{ maxHeight: 400, overflowY: 'auto', border: '1px solid #e8e8e8', borderRadius: 8 }}>
              {filteredItems.length === 0 ? (
                <div style={{ padding: 32, textAlign: 'center', color: '#888' }}>
                  <i className="fas fa-box-open" style={{ fontSize: 32, marginBottom: 8, display: 'block' }}></i>
                  No items found
                </div>
              ) : (
                filteredItems.map((i, idx) => (
                  <div
                    key={i._id || idx}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      padding: '14px 16px',
                      borderBottom: idx < filteredItems.length - 1 ? '1px solid #eee' : 'none',
                      cursor: 'pointer',
                      transition: 'background 0.2s ease'
                    }}
                    onMouseEnter={(e) => e.currentTarget.style.background = '#f5f5f5'}
                    onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
                  >
                    <div style={{ flex: 1 }} onClick={() => {
                      let itemCopy = { ...i };
                      if (entityId && itemCopy.overrides && itemCopy.overrides[entityId]) {
                        itemCopy.price = itemCopy.overrides[entityId];
                      }
                      delete itemCopy.overrides;
                      setNewLineFromItem(itemCopy);
                      toggleSaved(false);
                      setSearchTerm('');
                    }}>
                      <div style={{ fontWeight: 500, color: '#1a3a4a' }}>{i.description}</div>
                      {i.code && <div style={{ fontSize: 12, color: '#888' }}>Code: {i.code}</div>}
                    </div>
                    <div style={{ fontWeight: 600, color: '#19a6b7', marginRight: 16 }}>R {format(i.price)}</div>
                    <button
                      onClick={(e) => { e.stopPropagation(); setSelectedItem(i); setEditItem(true); }}
                      style={{ background: '#e8f4f7', border: 'none', borderRadius: 6, padding: '8px 12px', color: '#19a6b7', cursor: 'pointer' }}
                    >
                      <i className="fas fa-edit"></i>
                    </button>
                  </div>
                ))
              )}
            </div>
          </div>
        )}

        {/* Add/Edit Item Form */}
        {!showSaved && !editItem && (
          <div>
            {/* Main Fields */}
            <div style={fieldGroupStyle}>
              <label style={labelStyle}>Description <span style={{ color: '#e84651' }}>*</span></label>
              <input
                type="text"
                value={item.description || ''}
                onChange={(e) => onChangeText('description', e.target.value)}
                placeholder="Enter item description"
                style={inputStyle}
              />
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
              <div style={fieldGroupStyle}>
                <label style={labelStyle}>Unit Price <span style={{ color: '#e84651' }}>*</span></label>
                <div style={{ display: 'flex' }}>
                  <span style={{ padding: '12px 14px', background: '#1a3a4a', color: 'white', borderRadius: '8px 0 0 8px', fontWeight: 500 }}>R</span>
                  <input
                    type="number"
                    min="0"
                    step="any"
                    value={item.price || ''}
                    onChange={(e) => onChangeText('price', e.target.value)}
                    placeholder="0.00"
                    style={{ ...inputStyle, borderRadius: '0 8px 8px 0', borderLeft: 'none' }}
                  />
                </div>
              </div>

              <div style={fieldGroupStyle}>
                <label style={labelStyle}>Quantity <span style={{ color: '#e84651' }}>*</span></label>
                <input
                  type="number"
                  min="1"
                  step="1"
                  value={item.qty || ''}
                  onChange={(e) => onChangeText('qty', e.target.value)}
                  placeholder="1"
                  style={inputStyle}
                />
              </div>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
              <div style={fieldGroupStyle}>
                <label style={labelStyle}>Item Code <span style={{ color: '#888', fontWeight: 400 }}>(optional)</span></label>
                <input
                  type="text"
                  value={item.code || ''}
                  onChange={(e) => onChangeText('code', e.target.value)}
                  placeholder="SKU or code"
                  style={inputStyle}
                />
              </div>

              <div style={fieldGroupStyle}>
                <label style={labelStyle}>Category <span style={{ color: '#888', fontWeight: 400 }}>(optional)</span></label>
                <input
                  type="text"
                  value={item.category || ''}
                  onChange={(e) => onChangeText('category', e.target.value)}
                  placeholder="Category"
                  style={inputStyle}
                />
              </div>
            </div>

            <div style={fieldGroupStyle}>
              <label style={labelStyle}>Notes <span style={{ color: '#888', fontWeight: 400 }}>(optional)</span></label>
              <textarea
                value={item.notes || ''}
                onChange={(e) => onChangeText('notes', e.target.value)}
                placeholder="Additional notes..."
                rows={2}
                style={{ ...inputStyle, resize: 'vertical' }}
              />
            </div>

            <div style={fieldGroupStyle}>
              <label style={labelStyle}>Income Account</label>
              <select
                onChange={(e) => onChangeText('ledgerAccountId', e.target.value)}
                value={item.ledgerAccountId || ''}
                style={inputStyle}
              >
                <option value="">Select account...</option>
                {accounts.filter(t => !!t.income).map(i => (
                  <option key={i._id} value={i._id}>{i.account}: {i.name}</option>
                ))}
              </select>
            </div>

            {/* Options Section */}
            <div style={sectionStyle}>
              <div style={{ fontWeight: 600, color: '#1a3a4a', marginBottom: 12 }}>
                <i className="fas fa-cog" style={{ marginRight: 8, color: '#19a6b7' }}></i>
                Options
              </div>

              {!item.id && <SwitchEditComponent invert={true} header={'Save to item list'} onChangeText={onChangeText} prop={'save'} value={item.save} />}
              {!!item.save && <div style={{ fontSize: 12, color: '#888', marginTop: 4, marginBottom: 8 }}>Item will be saved when invoice is saved</div>}
              {item.id && <SwitchEditComponent invert={true} header={'Override client specific price'} onChangeText={onChangeText} prop={'saveClientPrice'} value={item.saveClientPrice} />}

              {tax && tax.hasTax && <SwitchEditComponent invert={true} header={`Apply ${tax.tD}`} onChangeText={onChangeText} prop={'hasTax'} value={item.hasTax} />}
              {tax && tax.hasSecondTax && <SwitchEditComponent invert={true} header={`Apply ${tax.tD2}`} onChangeText={onChangeText} prop={'hasSecondTax'} value={item.hasSecondTax} />}

              <SwitchEditComponent invert={true} header={'Track cost & supplier'} onChangeText={onChangeText} prop={'hasSupplier'} value={item.hasSupplier} />
            </div>

            {/* Supplier Section */}
            {!!item.hasSupplier && (
              <div style={{ ...sectionStyle, background: '#fff8e8', border: '1px solid #f0ad4e' }}>
                <div style={{ fontWeight: 600, color: '#1a3a4a', marginBottom: 12 }}>
                  <i className="fas fa-truck" style={{ marginRight: 8, color: '#f0ad4e' }}></i>
                  Cost & Supplier
                </div>

                <div style={fieldGroupStyle}>
                  <label style={labelStyle}>Unit Cost</label>
                  <div style={{ display: 'flex' }}>
                    <span style={{ padding: '12px 14px', background: '#f0ad4e', color: 'white', borderRadius: '8px 0 0 8px', fontWeight: 500 }}>R</span>
                    <input
                      type="number"
                      min="0"
                      step="any"
                      value={item.cost || ''}
                      onChange={(e) => onChangeText('cost', e.target.value)}
                      placeholder="0.00"
                      style={{ ...inputStyle, borderRadius: '0 8px 8px 0', borderLeft: 'none' }}
                    />
                  </div>
                </div>

                <div style={fieldGroupStyle}>
                  <label style={labelStyle}>Supplier</label>
                  <select onChange={(e) => onChangeText('supplierId', e.target.value)} value={item.supplierId || ''} style={inputStyle}>
                    <option value="">Select supplier...</option>
                    {suppliers.map(i => <option key={i._id} value={i._id}>{i.name}</option>)}
                  </select>
                </div>

                <div style={fieldGroupStyle}>
                  <label style={labelStyle}>Expense Account</label>
                  <select onChange={(e) => onChangeText('expenseAccountId', e.target.value)} value={item.expenseAccountId || ''} style={inputStyle}>
                    <option value="">Select account...</option>
                    {accounts.filter(t => !t.income).map(i => <option key={i._id} value={i._id}>{i.account}: {i.name}</option>)}
                  </select>
                </div>
              </div>
            )}
          </div>
        )}

        {/* Edit Saved Item */}
        {editItem && selectedItem && (
          <div style={sectionStyle}>
            <div style={fieldGroupStyle}>
              <label style={labelStyle}>Description</label>
              <input type="text" value={selectedItem.description || ''} onChange={(e) => handleItemChange('description', e.target.value)} style={inputStyle} />
            </div>
            <div style={fieldGroupStyle}>
              <label style={labelStyle}>Item Code</label>
              <input type="text" value={selectedItem.code || ''} onChange={(e) => handleItemChange('code', e.target.value)} style={inputStyle} />
            </div>
            <div style={fieldGroupStyle}>
              <label style={labelStyle}>Default Price</label>
              <div style={{ display: 'flex' }}>
                <span style={{ padding: '12px 14px', background: '#1a3a4a', color: 'white', borderRadius: '8px 0 0 8px', fontWeight: 500 }}>R</span>
                <input type="number" min="0" step="any" value={selectedItem.price || ''} onChange={(e) => handleItemChange('price', e.target.value)} style={{ ...inputStyle, borderRadius: '0 8px 8px 0', borderLeft: 'none' }} />
              </div>
            </div>
            {tax && <SwitchEditComponent invert={true} header={tax.tD} onChangeText={handleItemChange} prop={'hasTax'} value={selectedItem.hasTax} />}
            {tax && <SwitchEditComponent invert={true} header={tax.tD2} onChangeText={handleItemChange} prop={'hasSecondTax'} value={selectedItem.hasSecondTax} />}
            <div style={fieldGroupStyle}>
              <label style={labelStyle}>Account</label>
              <select onChange={(e) => handleItemChange('ledgerAccountId', e.target.value)} value={selectedItem.ledgerAccountId || ''} style={inputStyle}>
                <option value="">Select account...</option>
                {accounts.filter(i => !!i.income).map(i => <option key={i._id} value={i._id}>{i.account}: {i.name}</option>)}
              </select>
            </div>
          </div>
        )}
      </MDBModalBody>

      {/* Footer */}
      <div style={{
        padding: '16px 24px',
        background: '#f8f9fa',
        borderTop: '1px solid #e8e8e8',
        display: 'flex',
        justifyContent: 'space-between',
        gap: 12
      }}>
        {/* Left Side */}
        <div>
          {!showSaved && !editItem && (
            <button
              type="button"
              onClick={() => toggleSaved(true)}
              style={{ ...buttonStyle, background: 'transparent', color: '#19a6b7', border: '1px solid #19a6b7' }}
            >
              <i className="fas fa-list"></i>
              Load from Saved
            </button>
          )}
          {showSaved && !editItem && (
            <button
              type="button"
              onClick={() => { toggleSaved(false); setSearchTerm(''); }}
              style={{ ...buttonStyle, background: 'transparent', color: '#666', border: '1px solid #ddd' }}
            >
              <i className="fas fa-arrow-left"></i>
              Back
            </button>
          )}
          {editItem && (
            <button
              type="button"
              onClick={() => {
                Alert.fire({
                  title: 'Delete this saved item?',
                  showDenyButton: true,
                  showCancelButton: false,
                  confirmButtonText: 'Yes, delete',
                  denyButtonText: 'Cancel',
                }).then((result) => {
                  if (result.isConfirmed) {
                    deleteSavedItem(selectedItem);
                    setEditItem(false);
                    setError();
                    setSelectedItem();
                  }
                });
              }}
              style={{ ...buttonStyle, background: '#fef0f0', color: '#e84651' }}
            >
              <i className="fas fa-trash"></i>
              Delete
            </button>
          )}
        </div>

        {/* Right Side */}
        <div style={{ display: 'flex', gap: 12 }}>
          <button
            type="button"
            onClick={() => {
              if (editItem) {
                setEditItem(false);
                setSelectedItem();
                setError();
              } else {
                clearLineItem();
                setModalVisible(false);
              }
            }}
            style={{ ...buttonStyle, background: 'white', color: '#666', border: '1px solid #ddd' }}
          >
            Cancel
          </button>

          {!showSaved && !editItem && (
            <button
              type="button"
              onClick={() => { clearLineItem(); addLineItem(index, item); }}
              style={{ ...buttonStyle, background: '#19a6b7', color: 'white' }}
            >
              <i className="fas fa-check"></i>
              {index !== undefined ? 'Update Item' : 'Add Item'}
            </button>
          )}

          {editItem && (
            <button
              type="button"
              onClick={() => {
                if (!selectedItem.description || !selectedItem.price) {
                  setError('Please enter all required fields');
                  return;
                }
                saveLineItem(selectedItem);
                setEditItem(false);
                setError();
                setSelectedItem();
              }}
              style={{ ...buttonStyle, background: '#19a6b7', color: 'white' }}
            >
              <i className="fas fa-save"></i>
              Save Changes
            </button>
          )}
        </div>
      </div>
    </MDBModal>
  )
}

const ItemComponent = ({ header, value, deleteLineItem, index, setModalVisible, toEditItem, hideButton, total, item }) => {
  const actionButtonStyle = {
    width: 32,
    height: 32,
    borderRadius: 6,
    border: 'none',
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: 4,
    transition: 'all 0.2s ease'
  };

  return (
    <tr style={{ borderBottom: '1px solid #eee' }}>
      {!hideButton && (
        <td style={{ padding: '12px 8px', width: 80 }}>
          <button
            style={{ ...actionButtonStyle, background: '#e8f4f7', color: '#19a6b7' }}
            onClick={() => {
              toEditItem(item, index);
              setModalVisible(true)
            }}
            onMouseEnter={(e) => { e.currentTarget.style.background = '#19a6b7'; e.currentTarget.style.color = 'white'; }}
            onMouseLeave={(e) => { e.currentTarget.style.background = '#e8f4f7'; e.currentTarget.style.color = '#19a6b7'; }}
          >
            <i className="fas fa-edit" style={{ fontSize: 12 }}></i>
          </button>
          <button
            style={{ ...actionButtonStyle, background: '#fef0f0', color: '#e84651' }}
            onClick={() => deleteLineItem(index)}
            onMouseEnter={(e) => { e.currentTarget.style.background = '#e84651'; e.currentTarget.style.color = 'white'; }}
            onMouseLeave={(e) => { e.currentTarget.style.background = '#fef0f0'; e.currentTarget.style.color = '#e84651'; }}
          >
            <i className="fas fa-trash" style={{ fontSize: 12 }}></i>
          </button>
        </td>
      )}
      <td style={{ padding: '12px 8px' }}>
        <div style={{ fontWeight: 500, color: '#1a3a4a' }}>{header}</div>
        {item.code && <div style={{ fontSize: 12, color: '#888', marginTop: 2 }}>{item.code}</div>}
      </td>
      <td style={{ padding: '12px 8px', textAlign: 'center', color: '#666' }}>{format(item.qty)}</td>
      <td style={{ padding: '12px 8px', textAlign: 'right', color: '#666' }}>R {format(item.price)}</td>
      <td style={{ padding: '12px 8px', textAlign: 'right', fontWeight: 600, color: '#1a3a4a' }}>R {format(total)}</td>
    </tr>
  )
}

class LineItemComponent extends React.Component {
  setOrgLineItems = () => {
    let lineItems = [];
    console.log('lineitems');
    if (this.props.lineItems) lineItems = this.props.lineItems;
    return lineItems;
  }

  setOrgDiscount = () => {
    let discount = {
      hasDiscount: false,
      discountType: 'Percentage',
      discountValue: '10'
    };
    if (this.props.discount) discount = this.props.discount;
    return discount;
  }
  setOrgTax = () => {
    let tax = {
      hasTax: false,
      tD: 'VAT',
      tV: 15,
      inc1: true,
      hasSecondTax: false,
      t2D: 'PST',
      t2V: 5,
      ...this.props.company.tax
    };
    if (this.props.tax) tax = this.props.tax;
    return tax;
  }

  state = {
    newLineItem: { qty: "1", price: 0, ...this.props.tax },
    index: undefined,
    lineItems: this.setOrgLineItems(),
    modalVisible: false,
    discount: this.setOrgDiscount(),
    tax: this.setOrgTax(),
    showTaxSettings: false
  }

  setNewLineFromItem = (item) => {
    console.log(item, 'setNewLineFromItem')
    if (item) {
      this.setState({
        newLineItem: item
      });
    }
  }

  addLineItem = (index, item) => {
    if (!item.description || !item.price) return;
    if (!item.qty) item.qty = "1";

    let items = this.state.lineItems;
    if (index == undefined) {
      items = this.state.lineItems ? [...this.state.lineItems, { ...item }] : [{ ...item }]
    }
    else {
      items.splice(index, 1, item);
    }

    this.setState({
      index: undefined,
      lineItems: items,
      modalVisible: false
    });
    this.props.updateLineItems(this.props.prop, items);
  }

  clearLineItem = () => {
    this.setState({
      newLineItem: { qty: "1", price: 0, ...this.props.tax },
      index: undefined
    });
  }

  handleLineChange = (prop, value) => {
    var t = this.state.newLineItem;

    t[prop] = value;

    this.setState({
      newLineItem: t
    });
  }

  deleteLineItem = (index) => {
    let items = this.state.lineItems;
    items.splice(index, 1);

    this.setState({
      lineItems: items
    });
    this.props.updateLineItems(items);
  }

  toEditItem = (item, i) => {
    this.setState({
      newLineItem: item,
      index: i
    });
  }

  setDiscount = (key, value) => {
    let discount = {
      ...this.state.discount,
      [key]: value
    }
    this.setState({
      discount
    });
    if (this.props.updateDiscount) this.props.updateDiscount('discount', discount);
  }

  setTax = (key, tax) => {
    this.setState({
      tax
    });
    if (this.props.updateTax) this.props.updateTax('tax', tax);
  }

  toggleTaxSettings = () => {
    this.setState({
      showTaxSettings: !this.state.showTaxSettings
    });
  }

  render() {

    let permissions = this.props.permissions ? this.props.permissions : {};

    const setModalVisible = (b) => {
      this.setState({
        modalVisible: b
      });
    }

    let total = 0;
    let preTotal = 0;
    let discount = 0;

    const tableHeaderStyle = {
      background: '#1a3a4a',
      color: 'white',
      fontWeight: 500,
      fontSize: 11,
      textTransform: 'uppercase',
      letterSpacing: '0.5px',
      padding: '14px 8px'
    };

    return (
      <div style={{ paddingBottom: 20 }}>
        <div style={{
          border: '1px solid #e8e8e8',
          borderRadius: 8,
          overflow: 'hidden'
        }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr>
                {!this.props.view && <th style={{ ...tableHeaderStyle, width: 80 }}>Actions</th>}
                <th style={tableHeaderStyle}>Description</th>
                <th style={{ ...tableHeaderStyle, width: 80, textAlign: 'center' }}>Qty</th>
                <th style={{ ...tableHeaderStyle, width: 100, textAlign: 'right' }}>Amount</th>
                <th style={{ ...tableHeaderStyle, width: 120, textAlign: 'right' }}>Subtotal</th>
              </tr>
            </thead>
            <tbody style={{ background: 'white' }}>
              {this.state.lineItems && this.state.lineItems.length === 0 && (
                <tr>
                  <td colSpan={this.props.view ? 4 : 5} style={{ padding: 32, textAlign: 'center', color: '#888' }}>
                    <i className="fas fa-box-open" style={{ fontSize: 24, marginBottom: 8, display: 'block' }}></i>
                    No items added yet
                  </td>
                </tr>
              )}

              {this.state.lineItems && this.state.lineItems.map((item, i) => {
                let qty = item.qty ?? 1;
                preTotal += (parseFloat(item.price) * parseFloat(qty));
                if (this.state.discount.hasDiscount) {
                  if (this.state.discount.discountType == 'Amount') discount = -1 * parseFloat(this.state.discount.discountValue);
                  else discount = -1 * (preTotal / 100 * parseFloat(this.state.discount.discountValue));
                }
                total = preTotal + discount;

                return (<ItemComponent key={i} index={i} hideButton={!!this.props.view} deleteLineItem={this.deleteLineItem} setModalVisible={setModalVisible} toEditItem={this.toEditItem} editLineItem={this.editLineItem} item={item} total={(parseFloat(item.price) * parseFloat(qty)).toFixed(2)} header={item.description} value={qty + ' x R ' + parseFloat(item.price).toFixed(2)} />)
              })}
            </tbody>
          </table>

          {/* Add Item Button */}
          {!this.props.view && (
            <div
              onClick={() => setModalVisible(true)}
              style={{
                padding: '14px 20px',
                background: '#19a6b7',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 8,
                transition: 'background 0.2s ease'
              }}
              onMouseEnter={(e) => e.currentTarget.style.background = '#148a99'}
              onMouseLeave={(e) => e.currentTarget.style.background = '#19a6b7'}
            >
              <i className="fas fa-plus" style={{ color: 'white' }}></i>
              <span style={{ color: 'white', fontWeight: 500, fontSize: 14 }}>Add Item</span>
            </div>
          )}
        </div>

        <ItemFooterComponent viewOnly={!!this.props.view} toggleTaxSettings={this.toggleTaxSettings} showTaxSettings={this.state.showTaxSettings} setTax={this.setTax} tax={0} taxObj={this.state.tax} lineItems={this.state.lineItems} setDiscount={this.setDiscount} discountObj={this.state.discount} hideButton={true} header={'Total'} value={total} />

        {this.state.modalVisible && <ModalView
          myPriceListItems={this.props.myPriceListItems}
          permissions={permissions}
          accounts={this.props.accounts}
          suppliers={this.props.suppliers}
          index={this.state.index}
          entityId={this.props.entityId}
          setNewLineFromItem={this.setNewLineFromItem}
          addLineItem={this.addLineItem}
          clearLineItem={this.clearLineItem}
          modalVisible={this.state.modalVisible}
          setModalVisible={setModalVisible}
          newLineItem={this.state.newLineItem}
          tax={this.props.tax}
          entities={this.props.entities}
          deleteSavedItem={this.props.dispatchDeleteLineItem}
          saveLineItem={this.props.dispatchSaveLineItem}
          handleLineChange={this.handleLineChange} />}

      </div>);
  };
}

const mapStateToProps = state => ({
  myPriceListItems: state.companies.items,
  accounts: state.accounting.accounts,
  suppliers: state.suppliers.suppliers,
  company: state.companies.company,
  tax: state.companies.company.tax,
  entities: state.entities.entities
})

const mapDispatchToProps = {
  dispatchSaveLineItem: (item) => saveLineItem(item),
  dispatchDeleteLineItem: (item) => deleteLineItem(item)
}

export default connect(mapStateToProps, mapDispatchToProps)(LineItemComponent)
